var _defs, _path, _path2, _rect, _rect2, _rect3, _circle, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _polyline7, _polyline8, _circle2, _polyline9, _polyline10, _polyline11, _polyline12, _polyline13, _polyline14, _polyline15, _polyline16, _circle3, _polyline17, _polyline18, _polyline19, _polyline20, _polyline21, _polyline22, _polyline23, _polyline24, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRingbaseVault2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1063.18212 1030.91968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke:#5d5dff;stroke-linejoin:round;stroke-width:1.81174px;}.cls-1,.cls-2,.cls-4{stroke-linecap:round;}.cls-1{fill:url(#New_Gradient_Swatch_1);}.cls-2{fill:url(#linear-gradient);}.cls-3{opacity:0.1;fill:url(#radial-gradient);}.cls-4,.cls-5{fill:none;stroke:#fff;stroke-miterlimit:10;}.cls-4{stroke-width:9.81706px;}.cls-5{stroke-width:7.3628px;}.cls-6{isolation:isolate;}.cls-7{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    x1: 1070.82701,
    y1: 617.23038,
    x2: 12.89461,
    y2: 617.23038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5d5dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00033,
    stopColor: "#5c5cfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00943,
    stopColor: "#4b4cd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01929,
    stopColor: "#3b3db0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03038,
    stopColor: "#2e3190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04263,
    stopColor: "#222674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05648,
    stopColor: "#191d5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07265,
    stopColor: "#12164d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09264,
    stopColor: "#0d1142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12067,
    stopColor: "#0a0f3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19849,
    stopColor: "#090e39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70101,
    stopColor: "#0f1447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94667,
    stopColor: "#060b33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050a30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 141.81912,
    y1: 903.20033,
    x2: 949.00724,
    y2: 437.17005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#050a30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05333,
    stopColor: "#060b33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29899,
    stopColor: "#0f1447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80151,
    stopColor: "#090e39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87933,
    stopColor: "#0a0f3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90736,
    stopColor: "#0d1142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92735,
    stopColor: "#12164d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94352,
    stopColor: "#191d5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95737,
    stopColor: "#222674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96962,
    stopColor: "#2e3190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98071,
    stopColor: "#3b3db0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99057,
    stopColor: "#4b4cd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99967,
    stopColor: "#5c5cfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5d5dff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 542.77688,
    cy: 657.69084,
    r: 221.86977,
    gradientTransform: "translate(-0.4645 -36.04499) scale(0.98182)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5d5dff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53015,
    stopColor: "#060b33",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060b33",
    stopOpacity: 0.6
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ring base-vault-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1053.51812,672.63945,530.96622,979.57093c-20.499,12.04048-51.06054,10.16883-68.26122-4.18043L24.23145,609.60416c-17.20068-14.34926-14.5269-35.74237,5.972-47.78285L552.75541,254.88983c20.499-12.04048,51.06054-10.16883,68.26121,4.18043L1059.49017,624.8566C1076.69085,639.20586,1074.01707,660.599,1053.51812,672.63945Z",
    transform: "translate(-10.26975 -46.26815)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.8069,677.20576c.19151,7.49118,3.91311,14.98708,11.329,21.17364l438.47355,365.78634c17.20068,14.34926,47.76227,16.22091,68.26122,4.18043l522.5519-306.93148c10.24948-6.02024,16.04267-14.37864,17.12339-23.02564l-3.48739-93.28392c.65641,10.18993-5.23464,20.47129-17.25948,27.53432L529.24723,979.57093c-20.49895,12.04048-51.06054,10.16883-68.26122-4.18043L22.51246,609.60416c-7.655-6.386-11.37366-14.16715-11.33656-21.89812Z",
    transform: "translate(-10.26975 -46.26815)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 224.78905,
    y: 593.76728,
    width: 615.30931,
    height: 31.84111,
    rx: 14.60604
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 353.5476,
    y: 108.93131,
    width: 357.79221,
    height: 380,
    rx: 9.52941
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 370.76892,
    y: 124.9324,
    width: 323.34957,
    height: 323.34957,
    rx: 5.02941
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 532.44371,
    cy: 286.60719,
    r: 99.8564
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "434.158 304.345 402.368 304.345 402.368 268.87 434.158 268.87"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "630.729 268.87 662.52 268.87 662.52 304.345 630.729 304.345"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "475.812 368.863 453.38 391.499 428.464 366.431 450.708 343.984"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "589.076 204.352 611.507 181.715 636.423 206.783 614.18 229.23"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "550.05 384.916 550.05 416.683 514.837 416.683 514.837 384.916"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "514.837 188.308 514.837 156.531 550.05 156.531 550.05 188.298"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "614.481 343.554 637.003 366.003 612.11 390.841 589.656 368.459"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "450.409 229.664 427.884 207.212 452.777 182.373 475.232 204.755"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 532.44371,
    cy: 286.60719,
    r: 66.25173
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "467.82 271.961 448.404 263.719 457.601 242.054 477.016 250.295"
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "597.068 301.254 616.483 309.495 607.286 331.161 587.871 322.919"
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "476.533 322.162 456.965 330.171 448.247 308.402 467.651 300.46"
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "588.354 251.053 607.922 243.043 616.64 264.812 597.237 272.755"
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "517.711 351.211 509.476 370.612 487.97 361.484 496.206 342.083"
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "547.174 222.009 555.412 202.602 576.917 211.73 568.682 231.131"
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "567.784 342.653 575.719 362.202 554.077 370.919 546.165 351.428"
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "497.105 230.564 489.169 211.012 510.811 202.296 518.722 221.786"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 532.44371,
    cy: 286.60719,
    r: 39.73597
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "499.797 263.943 490.852 254.997 500.834 245.015 509.779 253.961"
  })), _polyline18 || (_polyline18 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "565.09 309.272 574.036 318.217 564.053 328.199 555.108 319.254"
  })), _polyline19 || (_polyline19 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "493.364 293.817 480.682 293.875 480.725 279.81 493.3 279.753"
  })), _polyline20 || (_polyline20 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "571.524 279.397 584.205 279.34 584.162 293.404 571.587 293.461"
  })), _polyline21 || (_polyline21 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "509.736 319.223 500.797 328.162 490.889 318.254 499.828 309.315"
  })), _polyline22 || (_polyline22 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "555.149 253.994 564.09 245.052 573.999 254.96 565.06 263.899"
  })), _polyline23 || (_polyline23 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "539.504 325.715 539.524 338.369 525.531 338.353 525.51 325.737"
  })), _polyline24 || (_polyline24 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "525.384 247.502 525.363 234.846 539.357 234.861 539.377 247.477"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M582.6911,76.994v.9408c-9.00262-.82407-20.35864-1.74655-34.75916-1.74655a334.31281,334.31281,0,0,0-73.288,8.07841,298.92687,298.92687,0,0,0-88.99215,35.53612c-.98953.60022-4.45288,2.74036-9.62042,6.36138-5.16492,3.61855-12.04188,8.718-19.9267,15.26385a332.11031,332.11031,0,0,0-53.57591,56.24134,276.8505,276.8505,0,0,0-32.39006,55.61406,241.306,241.306,0,0,0-20.00785,95.87079,245.92951,245.92951,0,0,0,10.07068,70.19651,265.071,265.071,0,0,0,24.10209,56.19706,298.04753,298.04753,0,0,0,53.08116,67.67509c3.54712,3.3578,6.301,5.76853,8.055,7.28139,3.5288,3.04539,8.8377,7.49294,15.90314,12.73751A309.02544,309.02544,0,0,0,468.1466,614.21393a292.57954,292.57954,0,0,0,72.34293,9.04762,293.785,293.785,0,0,0,113.75916-22.90193A314.40772,314.40772,0,0,0,721.1178,562.125c3.96859-2.96913,7.2199-5.52992,9.77487-7.57658a286.851,286.851,0,0,0,57.29319-61.35061c3.5733-5.21013,6.28273-9.5642,8.21728-12.78671a263.92553,263.92553,0,0,0,23.5445-50.64992,249.56856,249.56856,0,0,0,3.267-152.61149c-13.69895-46.36227-40.31937-87.80222-76.08639-120.72591a14.32513,14.32513,0,0,1-.22513-21.15292,16.64071,16.64071,0,0,1,22.51047-.21893c39.65184,36.50041,69.24608,82.51583,84.48168,134.09807l-.96358.25131c-15.18743-51.41929-44.68894-97.29076-84.2179-133.67813a15.59477,15.59477,0,0,0-21.09635.2053,13.42555,13.42555,0,0,0,.21066,19.82409c35.88987,33.03668,62.60295,74.62059,76.35012,121.14582a250.45409,250.45409,0,0,1-3.27842,153.14991,264.83718,264.83718,0,0,1-23.6259,50.82482c-1.94158,3.23421-4.6612,7.60466-8.24753,12.83379A287.81212,287.81212,0,0,1,731.54076,555.264c-2.56043,2.051-5.80561,4.61982-9.80034,7.59627a315.42184,315.42184,0,0,1-67.08566,38.35807,294.83949,294.83949,0,0,1-114.163,22.98289,293.64361,293.64361,0,0,1-72.6065-9.08026A310.04585,310.04585,0,0,1,360.723,563.97905c-7.09039-5.26307-12.41864-9.72683-15.95948-12.78262-1.76092-1.51889-4.52685-3.94013-8.08806-7.31127a299.00161,299.00161,0,0,1-53.25318-67.89357,265.97809,265.97809,0,0,1-24.18429-56.38975,246.81526,246.81526,0,0,1-10.107-70.44873A242.19481,242.19481,0,0,1,269.212,252.93032a277.7727,277.7727,0,0,1,32.49764-55.8,333.07646,333.07646,0,0,1,53.7327-56.40635c7.90872-6.56573,14.80785-11.68163,19.9913-15.31317,5.19011-3.6369,8.67513-5.79052,9.67672-6.39808A299.9616,299.9616,0,0,1,474.41024,83.353a335.3756,335.3756,0,0,1,73.5217-8.10444C562.37845,75.24859,573.768,76.17384,582.6911,76.994Z",
    transform: "translate(-10.26975 -46.26815)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M852.93171,269.40126a276.87666,276.87666,0,0,1-3.61425,169.21383A292.48051,292.48051,0,0,1,823.263,494.66388c-2.15276,3.575-5.18446,8.45391-9.16112,14.23817-3.96382,5.79191-8.91625,12.50021-14.80217,19.77782a319.35875,319.35875,0,0,1-48.43678,47.951c-4.00508,3.19889-9.97374,7.89732-17.6563,13.34548-7.70031,5.4576-17.14161,11.68045-28.24007,18.038a336.37252,336.37252,0,0,1-85.84817,34.62087,324.98324,324.98324,0,0,1-77.19148,9.60916,328.54364,328.54364,0,0,1-115.93714-20.7298,342.48381,342.48381,0,0,1-75.36362-39.49687,312.2416,312.2416,0,0,1-26.054-20.17414c-1.46375-1.26515-3.60507-3.13518-6.252-5.56859-2.64519-2.43664-5.80239-5.45611-9.32815-8.979a326.08759,326.08759,0,0,1-24.60555-27.74269c-17.98514-22.74339-37.77974-53.87523-50.79928-92.61669A272.5517,272.5517,0,0,1,219.288,349.75542a269.0111,269.0111,0,0,1,10.28-73.83325,282.87289,282.87289,0,0,1,25.65881-61.07582c20.62006-36.59744,46.53314-64.82666,68.42577-84.69246a347.46108,347.46108,0,0,1,35.81575-28.52c4.78714-3.30273,8.09768-5.3619,9.50586-6.20749A330.94682,330.94682,0,0,1,467.44292,56.0868a367.07493,367.07493,0,0,1,80.489-8.879,359.63861,359.63861,0,0,1,36.343,1.81984c8.188.83148,14.11214,7.74486,13.23341,15.44916C596.682,71.662,590.21676,76.9952,582.6911,76.994c-8.92315-.82016-20.31265-1.74541-34.75916-1.74544a335.3756,335.3756,0,0,0-73.5217,8.10444,299.9616,299.9616,0,0,0-89.29986,35.65975c-1.00159.60756-4.48661,2.76118-9.67672,6.39808-5.18345,3.63154-12.08258,8.74744-19.9913,15.31317a333.07646,333.07646,0,0,0-53.7327,56.40635,277.7727,277.7727,0,0,0-32.49764,55.8,242.19481,242.19481,0,0,0-20.08113,96.22279,246.81526,246.81526,0,0,0,10.107,70.44873,265.97809,265.97809,0,0,0,24.18429,56.38975,299.00161,299.00161,0,0,0,53.25318,67.89357c3.56121,3.37114,6.32714,5.79238,8.08806,7.31127,3.54084,3.05579,8.86909,7.51955,15.95948,12.78262A310.04585,310.04585,0,0,0,467.88531,615.121a293.64361,293.64361,0,0,0,72.6065,9.08026,294.83949,294.83949,0,0,0,114.163-22.98289,315.42184,315.42184,0,0,0,67.08566-38.35807c3.99473-2.97645,7.23991-5.54524,9.80034-7.59627a287.81212,287.81212,0,0,0,57.48563-61.55715c3.58633-5.22913,6.306-9.59958,8.24753-12.83379a264.83718,264.83718,0,0,0,23.6259-50.82482,250.45409,250.45409,0,0,0,3.27842-153.14991c-13.74717-46.52523-40.46025-88.10914-76.35012-121.14582a13.42555,13.42555,0,0,1-.21066-19.82409,15.59477,15.59477,0,0,1,21.09635-.2053C808.24277,172.1105,837.74428,217.982,852.93171,269.40126Z",
    transform: "translate(-10.26975 -46.26815)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M852.93171,269.40126l.96358-.25131a277.76217,277.76217,0,0,1-3.62566,169.75227,293.39346,293.39346,0,0,1-26.13612,56.22412c-2.15969,3.58658-5.20157,8.48184-9.1911,14.28481-3.97644,5.81035-8.90838,12.53333-14.84817,19.83932A320.32667,320.32667,0,0,1,751.51047,577.347c-4.01309,3.20528-9.99738,7.91605-17.70157,13.37955-7.72251,5.47334-17.1911,11.71418-28.322,18.09031a337.40618,337.40618,0,0,1-86.11256,34.72681,326.04739,326.04739,0,0,1-77.445,9.64046,329.59953,329.59953,0,0,1-116.3089-20.79624,343.505,343.505,0,0,1-75.589-39.61468,313.22916,313.22916,0,0,1-26.13612-20.23783c-1.46859-1.26933-3.6178-3.14625-6.27487-5.589-2.65445-2.44517-5.822-5.45612-9.35864-9.00826a327.0426,327.0426,0,0,1-24.678-27.82425c-18.03665-22.80845-37.89-54.03232-50.95026-92.89427A273.43946,273.43946,0,0,1,218.288,349.75442a269.897,269.897,0,0,1,10.31413-74.07582,283.78046,283.78046,0,0,1,25.74084-61.2719c20.68063-36.70459,46.66492-65.011,68.61519-84.929A348.45365,348.45365,0,0,1,358.877,100.87609c4.80629-3.316,8.13613-5.38724,9.5576-6.24083a331.97857,331.97857,0,0,1,98.77486-39.46217,368.13755,368.13755,0,0,1,80.72252-8.90494,360.70233,360.70233,0,0,1,36.45026,1.82526c8.73822.888,15.05759,8.2629,14.12042,16.484-.8822,7.6676-7.78011,13.35741-15.81152,13.35741V76.994c7.52566.0012,13.99092-5.332,14.81726-12.51716.87873-7.7043-5.04545-14.61768-13.23341-15.44916a359.63861,359.63861,0,0,0-36.343-1.81984,367.07493,367.07493,0,0,0-80.489,8.879,330.94682,330.94682,0,0,0-98.46881,39.33963c-1.40818.84559-4.71872,2.90476-9.50586,6.20749a347.46108,347.46108,0,0,0-35.81575,28.52c-21.89263,19.8658-47.80571,48.095-68.42577,84.69246a282.87289,282.87289,0,0,0-25.65881,61.07582,269.0111,269.0111,0,0,0-10.28,73.83325,272.5517,272.5517,0,0,0,14.29915,87.18128c13.01954,38.74146,32.81414,69.8733,50.79928,92.61669a326.08759,326.08759,0,0,0,24.60555,27.74269c3.52576,3.52284,6.683,6.54231,9.32815,8.979,2.647,2.43341,4.78827,4.30344,6.252,5.56859a312.2416,312.2416,0,0,0,26.054,20.17414,342.48381,342.48381,0,0,0,75.36362,39.49687,328.54364,328.54364,0,0,0,115.93714,20.7298,324.98324,324.98324,0,0,0,77.19148-9.60916,336.37252,336.37252,0,0,0,85.84817-34.62087c11.09846-6.35756,20.53976-12.58041,28.24007-18.038,7.68256-5.44816,13.65122-10.14659,17.6563-13.34548a319.35875,319.35875,0,0,0,48.43678-47.951c5.88592-7.27761,10.83835-13.98591,14.80217-19.77782,3.97666-5.78426,7.00836-10.66312,9.16112-14.23817a292.48051,292.48051,0,0,0,26.05446-56.04879,276.87666,276.87666,0,0,0,3.61425-169.21383Z",
    transform: "translate(-10.26975 -46.26815)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingbaseVault2);
export default __webpack_public_path__ + "static/media/ring base-vault-2.2bff4a66932ce78f5c41ce00357b4545.svg";
export { ForwardRef as ReactComponent };